var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadioGroup',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.updateValue}},_vm._l((_vm.field.values),function(fieldValue){return _c('Radio',{key:fieldValue.id,attrs:{"label":fieldValue.value}},[_vm._v(" "+_vm._s(fieldValue.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }